import type React from "react";
import { useEffect } from "react";
import { getTitle } from "src/page.ts";
import { trackPageView } from "src/utils/pulseHelper.ts";
import Bruktbilgruppen from "./client/Bruktbilgruppen.tsx";
import MobilityPool from "./client/MobilityPool.tsx";
import Mrf from "./client/Mrf.tsx";
import Nbas from "./client/Nbas.tsx";
import Nbf from "./client/Nbf.tsx";
import Ncb from "./client/Ncb.tsx";
import Nmcf from "./client/Nmcf.tsx";
import Norboat from "./client/Norboat.tsx";
import Smabatregisteret from "./client/Smabatregisteret.tsx";
import Sweboat from "./client/Sweboat.tsx";
import { useAppConfig } from "./context/AppConfigProviderContext.tsx";
import { TradeOrgPages } from "./types/tradeorgPages.ts";

type PageComponentMap = {
  [K in TradeOrgPages]: () => React.ReactNode;
};

const pageComponents: PageComponentMap = {
  [TradeOrgPages.NBF]: Nbf,
  [TradeOrgPages.Norboat]: Norboat,
  [TradeOrgPages.NCB]: Ncb,
  [TradeOrgPages.NMCF]: Nmcf,
  [TradeOrgPages.MobilityPool]: MobilityPool,
  [TradeOrgPages.Bruktbilgruppen]: Bruktbilgruppen,
  [TradeOrgPages.Smabatregisteret]: Smabatregisteret,
  [TradeOrgPages.MRF]: Mrf,
  [TradeOrgPages.Sweboat]: Sweboat,
  [TradeOrgPages.NBAS]: Nbas,
};

const App = () => {
  const { pageName } = useAppConfig();

  useEffect(() => {
    trackPageView(getTitle(pageName), pageName);
  }, [pageName]);

  const PageComponent = pageName && pageComponents[pageName];

  return <main className="page-container">{PageComponent && <PageComponent />}</main>;
};

export default App;
